var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyCheckins(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 10,
    viewBox: "0 0 23 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.640625 5.28125V4.125H4.51562V5.28125H0.640625ZM5.47687 5.28125V4.125H9.35187V5.28125H5.47687ZM10.8444 8.1875C10.8444 7.82292 10.9329 7.5651 11.11 7.41406C11.2871 7.25781 11.5032 7.17969 11.7584 7.17969C12.0241 7.17969 12.248 7.25781 12.4303 7.41406C12.6126 7.5651 12.7037 7.82292 12.7037 8.1875C12.7037 8.54688 12.6126 8.8099 12.4303 8.97656C12.248 9.13802 12.0241 9.21875 11.7584 9.21875C11.5032 9.21875 11.2871 9.13802 11.11 8.97656C10.9329 8.8099 10.8444 8.54688 10.8444 8.1875ZM10.8444 1.25781C10.8444 0.882812 10.9329 0.619792 11.11 0.46875C11.2871 0.3125 11.5032 0.234375 11.7584 0.234375C12.0241 0.234375 12.248 0.3125 12.4303 0.46875C12.6126 0.619792 12.7037 0.882812 12.7037 1.25781C12.7037 1.61198 12.6126 1.86979 12.4303 2.03125C12.248 2.19271 12.0241 2.27344 11.7584 2.27344C11.5032 2.27344 11.2871 2.19271 11.11 2.03125C10.9329 1.86979 10.8444 1.61198 10.8444 1.25781ZM14.1962 5.28125V4.125H18.0712V5.28125H14.1962ZM19.0325 5.28125V4.125H22.9075V5.28125H19.0325Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyCheckins);
export default __webpack_public_path__ + "static/media/empty_checkins.8c421c98f9835576dedcadd2a196582e.svg";
export { ForwardRef as ReactComponent };